"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  en: {
    accessibilityLabel: 'Search',
    clearButtonAccessibilityLabel: 'Clear',
    submitButtonAccessibilityLabel: 'Search'
  },
  fr: {
    accessibilityLabel: 'Chercher',
    clearButtonAccessibilityLabel: 'Effacer',
    submitButtonAccessibilityLabel: 'Chercher'
  }
};